// System
import DeleteIcon from '@mui/icons-material/Delete';
import { Divider, Stack, Typography, Button } from '@mui/material';

// Redux
import { useAviatorRoleDrawer } from '@Modal/hooks/aviatorRoles/useAviatorRoleDrawer';
import { useAviatorPermissions } from '@Modal/hooks/aviatorRoles/useAviatorPermissions';
import { useDispatch } from 'react-redux';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';

export const AviatorRoleDetails = () => {
  const dispatch = useDispatch();
  const { userPermissions } = useAuthorization();
  const { selectedAviatorRoleData } = useAviatorRoleDrawer();
  const {
    setSelectedRolePermissionToDelete,
    setShowSelectedRolePermissionDeleteModal,
    setShowAddAviatorPermissionsModal,
  } = useAviatorPermissions();
  const { permissions } = selectedAviatorRoleData;
  const permissionToManagePermissions = userPermissions?.includes('CAN_MANAGE_PERMISSIONS');

  const handleDeleteIconClick = (permission: string) => {
    dispatch(setSelectedRolePermissionToDelete(permission));
    dispatch(setShowSelectedRolePermissionDeleteModal(true));
  };

  const handleAddPermissionsClick = () => {
    dispatch(setShowAddAviatorPermissionsModal(true));
  };

  return (
    <Stack direction="column" spacing={2} padding="24px">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h5">Permissions</Typography>
        {permissionToManagePermissions && (
          <Button
            sx={{ width: '200px' }}
            size="large"
            variant="contained"
            onClick={handleAddPermissionsClick}
          >
            Add Permissions
          </Button>
        )}
      </Stack>
      {permissions?.map((permission) => (
        <>
          <Divider sx={{ margin: '0px' }} />
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography key={permission}>
              {permission
                .replace(/_/g, ' ')
                .toLowerCase()
                .replace(/^\w/, (c) => c.toUpperCase())}
            </Typography>
            {permissionToManagePermissions && (
              <DeleteIcon
                sx={{ color: 'red', cursor: 'pointer' }}
                onClick={() => handleDeleteIconClick(permission)}
              />
            )}
          </Stack>
        </>
      ))}
    </Stack>
  );
};
